import Button from "@pathwright/ui/src/components/button/Button"
import DropdownItem from "@pathwright/ui/src/components/dropdown/DropdownItem"
import DropdownMenu from "@pathwright/ui/src/components/dropdown/DropdownMenu"
import DropdownTrigger from "@pathwright/ui/src/components/dropdown/DropdownTrigger"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Screensize from "@pathwright/ui/src/components/ui/Screensize"
import Text from "@pathwright/ui/src/components/ui/Text"
import {
  ENROLLMENT_ROLE_FACILITATOR,
  ENROLLMENT_ROLE_OBSERVER,
  ENROLLMENT_ROLE_STUDENT,
  ROLE_LABELS,
  ROLE_TYPE_OFFERING
} from "@pathwright/web/src/modules/invitation/constants"
import capitalize from "lodash/capitalize"

const MemberTypeFilter = ({ onFilter, role }) => (
  <Screensize.Consumer>
    {(screensize) => (
      <DropdownTrigger
        style={{ marginLeft: 10 }}
        alignment="left"
        renderDropdown={() => (
          <DropdownMenu closeOnClick>
            <Text.H6
              style={{
                marginBottom: "5px",
                padding: "0 10px"
              }}
            >
              Filter by...
            </Text.H6>
            <DropdownItem label={"All"} onClick={() => onFilter(null)} />
            {[
              ENROLLMENT_ROLE_OBSERVER,
              ENROLLMENT_ROLE_STUDENT,
              ENROLLMENT_ROLE_FACILITATOR
              // ENROLLMENT_ROLE_TEACHER,
            ].map((r, i) => (
              <DropdownItem
                key={i}
                label={capitalize(ROLE_LABELS[ROLE_TYPE_OFFERING][r])}
                onClick={() => onFilter(r)}
              />
            ))}
          </DropdownMenu>
        )}
      >
        <Button styleType="blank" color="#888">
          {screensize === "sm" ? (
            <Pathicon icon="badge-key" />
          ) : (
            <>
              {capitalize(ROLE_LABELS[ROLE_TYPE_OFFERING][role]) || "All"}
              <Pathicon icon="chevron-down" />
            </>
          )}
        </Button>
      </DropdownTrigger>
    )}
  </Screensize.Consumer>
)

export default MemberTypeFilter
